import {Arrow, Content, Portal, Root, Trigger} from '@radix-ui/react-popover';
import clsx from 'clsx';

export const Popover = Root;
export const PopoverTrigger = Trigger;

export const PopoverContent = ({
  ref: forwardedRef,
  children,
  className,
  ...props
}: React.ComponentProps<typeof Content> & {
  ref?: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <Portal>
      <Content
        sideOffset={5}
        {...props}
        ref={forwardedRef}
        className={clsx(
          'ring-opacity-5 max-h-radix-popover-content-available max-w-radix-popover-content-available overflow-hidden rounded-md bg-slate1 p-4 text-base shadow-lg outline-1 -outline-offset-1 outline-slate6 focus-visible:outline-2 sm:text-sm',
          className
        )}
      >
        {children}
        <Arrow className="fill-slate1 dark:hidden" />
      </Content>
    </Portal>
  );
};
PopoverContent.displayName = 'PopoverContent';
